import React from 'react';
import './App.css';

import Routes from "./services/Routes";
//import Home from "./pages/Home"

function App() {
  return (
    <Routes />
  );
}

export default App;
